<template>
	<div v-if="parameter && displayParameter" class="car-parameter">
		<div class="car-parameter__icon">
			<GlobalIcon v-if="parameterIcon" class="car-parameter__icon" :name="parameterIcon" />
			<GlobalIcon v-else-if="parameter.icon" class="car-parameter__icon" :name="parameter.icon" />
			<GlobalIcon v-else class="car-parameter__icon" name="orbit" />
		</div>
		<div v-if="parameter.value" class="car-parameter__value">
			{{
				i18nService.$tDynamic('data.group_map_translations', parametersMapTranslations[parameter.value])
					? capitalizeFirstLetter(i18nService.$tDynamic('data.group_map_translations', parametersMapTranslations[parameter.value]))
					: parameter.value
			}}
			<span v-if="parameter.valueLabel">
				<span v-if="isElectric && parameter.name === 'Average Fuel Consumption'"> kWh / 100 km </span>
				<span v-else>
					{{ parameter.valueLabel }}
				</span>
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	parameter: IProductParameterModel
	isElectric: boolean
}>()

const paremetersToNotDisplay = ['Image', 'popularity', 'Deposit', 'Big Bags Capacity', 'Small Bags Capacity']
const i18nService = usei18nService()

const displayParameter = computed(() => {
	return !paremetersToNotDisplay.includes(props.parameter.name)
})

// todo; delete after icon system is added
const parameterIcon = computed(() => {
	switch (props.parameter.name) {
		case 'Transmission':
			return 'orbit'
		case 'Seats':
			return 'seat-icon'
		case 'Fuel Type':
			return 'gas-station'
		case 'Average Fuel Consumption':
			return 'wheel'
		case 'Doors':
			return 'car-door'
		case 'Color':
			return 'battery'
		case 'Trunk Capacity':
			return 'sack'
		case 'Year':
			return 'calendar'
		default:
			return ''
	}
})
</script>

<style lang="scss" src="./CarParameter.scss"></style>
